<template>
  <el-dialog
    title="修改课件目录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <div class="common-form">修改课件目录</div>
        
        <!-- 所属组织 -->
        <el-form-item label="所属组织" prop="ma_organization_id">
          <el-select 
            v-model="form.ma_organization_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            />
          </el-select>
        </el-form-item>

        <!-- 所属行业：多选级联 -->
        <el-form-item label="所属行业" prop="industry_id">
          <el-cascader
            v-model="form.industry_id"
            :options="industryTree"
            :props="industryCascaderProps"
            placeholder="请选择所属行业（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('industry_id', $event)"
          ></el-cascader>
        </el-form-item>

        <!-- 培训类别：多选级联 -->
        <el-form-item label="培训类别" prop="class_id">
          <el-cascader
            v-model="form.class_id"
            :options="classTree"
            :props="classCascaderProps"
            placeholder="请选择培训类别（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('class_id', $event)"
          ></el-cascader>
        </el-form-item>

        <!-- 上级目录：单选级联 -->
        <el-form-item label="上级目录" prop="p_id">
          <el-cascader
            v-model="form.p_id"
            :options="directoryTree"
            :props="directoryCascaderProps"
            placeholder="请选择上级目录（顶级目录请留空）"
            style="width: 100%;"
            clearable
            filterable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="课件目录名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入课件目录名称" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
        上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: { 
    Upload, 
    Categoryas, 
    draggable, 
    Uediter 
  },
  data() {
    return {
      organizationList: [],
      isupload: false,
      isImg: false,
      ueditor: { 
        text: '', 
        config: { 
          initialFrameWidth: 400, 
          initialFrameHeight: 500 
        } 
      },
      // 无限级树形数据
      industryTree: [],
      classTree: [],
      directoryTree: [],
      // 行业多选配置
      industryCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_industry_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      // 类别多选配置
      classCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_class_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      // 上级目录单选配置
      directoryCascaderProps: {
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_directory_id',
        label: 'name',
        children: 'children',
        clearable: true
      },
      form: {
        name: '',
        sort: 50,
        industry_id: [],
        class_id: [],
        p_id: [],
        ma_organization_id: '',
        courseware_directory_id: 0
      },
      loading: false,
      // 表单验证
      rules: {
        name: [{ required: true, message: '请输入课件目录名称', trigger: 'blur' }],
        ma_organization_id: [{ required: true, message: '请选择所属组织', trigger: 'blur' }],
        industry_id: [{ 
          required: true, 
          message: '请选择所属行业', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择所属行业'));
            } else {
              callback();
            }
          }
        }],
        class_id: [{ 
          required: true, 
          message: '请选择培训类别', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择培训类别'));
            } else {
              callback();
            }
          }
        }]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    // 初始化加载树形数据
    this.getTree('courseware_industry');
    this.getTree('courseware_class');
    this.getTree('courseware_directory');
    this.loadOrganization();
    this.getDetail();
  },
  props: {
    open_add: {
      type: Boolean,
      default: false
    },
    courseware_directory_id: {
      type: [Number, String],
      default: 0
    }
  },
  watch: {
    courseware_directory_id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getDetail();
        }
      }
    }
  },
  methods: {
    // 加载组织列表
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'index',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.organizationList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list) {
          this.organizationList = response.data.list || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.organizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.organizationList = [];
      }
    },

    // 加载树形数据
    getTree: async function(table) {
      try {
        var response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: table,
        });
        if (response.code === 1) {
          if (table === 'courseware_industry') {
            this.industryTree = response.data.list || [];
          } else if (table === 'courseware_class') {
            this.classTree = response.data.list || [];
          } else if (table === 'courseware_directory') {
            this.directoryTree = response.data.list || [];
          }
        } else {
          this.$message.error(response.msg || '加载数据失败');
        }
      } catch (error) {
        console.error('加载' + table + '树形数据失败:', error);
        this.$message.error('加载分类数据失败，请稍后重试');
      }
    },

    // 获取详情
    async getDetail() {
      if (!this.courseware_directory_id) return;
      
      try {
        const response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'detail',
          courseware_directory_id: this.courseware_directory_id,
        });
        
        this.loading = false;
        if (response.code === 1 && response.data) {
          const detailData = response.data;
          
          // 格式化数据以匹配级联选择器的要求
          this.form = {
            name: detailData.name || '',
            sort: detailData.sort || 50,
            ma_organization_id: detailData.ma_organization_id || '',
            courseware_directory_id: detailData.courseware_directory_id,
            // 格式化行业ID（字符串转数组）
            industry_id: detailData.courseware_industry_id ? 
              this.formatIdsToCascaderArray(detailData.courseware_industry_id, 'courseware_industry_id') : [],
            // 格式化类别ID（字符串转数组）
            class_id: detailData.courseware_class_id ? 
              this.formatIdsToCascaderArray(detailData.courseware_class_id, 'courseware_class_id') : [],
            // 格式化上级目录ID（数字转数组）
            p_id: detailData.p_id ? 
              this.findPathInTree(this.directoryTree, detailData.p_id, 'courseware_directory_id') : []
          };
        }
      } catch (error) {
        console.error('加载目录失败:', error);
        this.$message.error('加载目录失败');
      }
    },

    // 将逗号分隔的ID字符串转换为级联选择器需要的数组格式
    formatIdsToCascaderArray(idString, idField) {
      if (!idString) return [];
      
      const ids = idString.split(',').filter(id => id.trim());
      const result = [];
      
      // 遍历每个ID，找到其在树中的完整路径
      ids.forEach(id => {
        const path = this.findPathInTree(
          idField === 'courseware_industry_id' ? this.industryTree : 
          idField === 'courseware_class_id' ? this.classTree : [],
          parseInt(id),
          idField
        );
        if (path.length > 0) {
          result.push(path);
        }
      });
      
      return result;
    },

    // 在树中查找节点的完整路径
    findPathInTree(tree, targetId, idField, currentPath = []) {
      if (!tree || !Array.isArray(tree)) return [];
      
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        const newPath = [...currentPath, node[idField]];
        
        if (node[idField] === targetId) {
          return newPath;
        }
        
        if (node.children && node.children.length > 0) {
          const childPath = this.findPathInTree(node.children, targetId, idField, newPath);
          if (childPath.length > 0) {
            return childPath;
          }
        }
      }
      
      return [];
    },

    // 处理级联选择器变化（父子互斥逻辑）
    handleCascaderChange: function(field, selectedArr) {
      if (!Array.isArray(selectedArr) || selectedArr.length === 0) {
        this.$set(this.form, field, []);
        return;
      }
      
      var selectCopy = JSON.parse(JSON.stringify(selectedArr));
      var finalSelect = [];
      
      selectCopy.sort((a, b) => a.length - b.length);
      
      for (var i = 0; i < selectCopy.length; i++) {
        var currentPath = selectCopy[i];
        var isChild = false;
        
        for (var j = 0; j < finalSelect.length; j++) {
          var existingPath = finalSelect[j];
          
          if (currentPath.length > existingPath.length) {
            var isPrefix = true;
            for (var k = 0; k < existingPath.length; k++) {
              if (currentPath[k] !== existingPath[k]) {
                isPrefix = false;
                break;
              }
            }
            if (isPrefix) {
              isChild = true;
              break;
            }
          }
        }
        
        if (!isChild) {
          finalSelect.push(currentPath);
        }
      }
      
      this.$set(this.form, field, finalSelect);
    },

    chooseCategory: function() {
      this.iscategorya = true;
    },
    
    openUpload: function(e) {
      this.isupload = true;
    },
    
    dialogFormVisible: function(result) {
      this.$emit('close', { openDialog: false, type: '' });
    },
    
    cancelFunc: function() {
      this.dialogFormVisible('error');
    },

    // 提交表单
    onSubmit: async function() {
      try {
        await this.$refs.form.validate();
      } catch (err) {
        console.log('表单验证失败:', err);
        return;
      }
      
      this.loading = true;

      // 处理多选值：二维数组 → 逗号分隔字符串（取最后一级ID）
      var handleMultiple = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return '';
        var ids = [];
        for (var i = 0; i < arr.length; i++) {
          if (Array.isArray(arr[i]) && arr[i].length > 0) {
            ids.push(arr[i][arr[i].length - 1]);
          }
        }
        return ids.join(',');
      };
      
      // 处理单选值：一维数组 → 最后一级ID
      var handleSingle = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return 0;
        return arr[arr.length - 1];
      };

      // 构造提交数据
      var formData = {
        courseware_directory_id: this.form.courseware_directory_id,
        name: this.form.name,
        sort: this.form.sort,
        courseware_industry_id: handleMultiple(this.form.industry_id),
        courseware_class_id: handleMultiple(this.form.class_id),
        ma_organization_id: this.form.ma_organization_id,
        p_id: handleSingle(this.form.p_id)
      };

      try {
        var response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'edit',
          ...formData,
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '修改目录成功');
          this.dialogFormVisible('success');
        } else {
          this.$message.error(response.msg || '修改目录失败');
        }
      } catch (error) {
        console.error('修改目录失败:', error);
        this.$message.error('修改目录失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    // 图片上传处理
    returnProductImgsFunc: function(e) {
      if (!e || e.length === 0) return;
      
      var imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      var isLegal = true;

      for (var i = 0; i < e.length; i++) {
        var element = e[i];
        var filePath = element.file_path || '';
        var ext = filePath.split(".").pop() || '';
        if (imgExpt.indexOf(ext.toLowerCase()) === -1) {
          isLegal = false;
          break;
        }
      }
      
      if (!isLegal) {
        this.$message.error("图片类型有误，请选择bmp/jpg/jpeg/png/gif格式");
        return;
      }
      
      if (this.code === 'album') {
        var newAlbum = this.form.image ? this.form.image.concat(e) : e;
        this.$set(this.form, "image", newAlbum);
      } else {
        var newBannar = this.form.bannar ? this.form.bannar.concat(e) : e;
        this.$set(this.form, "bannar", newBannar);
      }
      this.isProductUpload = false;
    },
    
    // 删除图片
    deleteImg: function(index, code) {
      if (code === 'album' && this.form.image) {
        this.form.image.splice(index, 1);
      } else if (code === 'bannar' && this.form.bannar) {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.max-w460 {
  max-width: 460px;
  width: 100%;
}
.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}
.pb50 {
  padding-bottom: 50px;
}
</style>

<style>
/* 多选级联组件样式优化 */
.el-cascader__tags {
  flex-wrap: wrap !important;
  white-space: normal !important;
  min-height: 32px;
  line-height: normal;
}

.el-cascader__tag {
  margin: 2px 4px 2px 0 !important;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-cascader__input {
  min-height: 32px !important;
  line-height: 32px !important;
  padding: 0 12px !important;
}

.el-cascader__search-input {
  min-height: 30px !important;
}

.el-cascader__dropdown {
  max-height: 400px !important;
  overflow-y: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/courseware_directory/index/part/edit.vue